var commitDate = '2019110311';
var Manager = {
	opts : ["opt-item", "opt-size", "opt-part", "opt-brand", "opt-merit", "opt-dlv"],
	rendableOpts : ["brand", "size",  "price", "meritDlv", "dlv"],
	condition:null,
	lseq:null,
	template:null,
	init : function(baseUrl, ajaxUrl, mainParam, defaultCategory, brandGrpSect, luxcosSectId  ) {
		var _this = this;	
		
		if (!Array.indexOf) {
		  Array.prototype.indexOf = function (obj, start) {
		    for (var i = (start || 0); i < this.length; i++) {
		      if (this[i] == obj) {
		        return i;
		      }
		    }
		    return -1;
		  }
		}

		_this.baseUrl = baseUrl ;
		_this.ajaxUrl = ajaxUrl ;
		_this.originalParam = mainParam;
			
//		SelectedFilters.init(brandGrpSect);	-
		Filter.init(defaultCategory, brandGrpSect);
		Category.init(luxcosSectId);
					
		// 컨디션 초기화
    	_this.condition = ( $('#condition-data').html().length > 0 ) ? $.parseJSON($('#condition-data').html()) : {};
		
//		BrandLayer.init();
    	
		
		HistoryManager.init( Filter.getParam, Manager.loadAjax );
    	
    	
	},
	loadAjax:function(forceRender, callback ){
		
		if( typeof forceRender == 'function' && typeof callback == undefined  ){
			callback = forceRender;
			forceRender = false;
		}
		
		forceRender = ( Filter.forceRender || forceRender );
		
		var _this = Manager;
		var url = _this.ajaxUrl;	
		var param = "?"+ _this.originalParam;					
		var jbpGbn = $('#filter-sort').attr('jbp-gbn');

		if( typeof history.state != 'undefined' ){
            if( HistoryManager.eh ){
				if (jbpGbn == 'NEW') {
					param += "&conrNo="+HistoryManager.sectId + "&eh="+HistoryManager.eh;
				} else {
					param += "&sectId="+HistoryManager.sectId + "&eh="+HistoryManager.eh;
				}
            }else{
                var currentUrl = document.location.href;
                if(currentUrl.indexOf("grand") > -1 || currentUrl.indexOf("signature") > -1){
                    var params = {};
                    window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(str, key, value) {
                        params[key] = value;
                    });

                    param += "&sectId="+params.sectId ;
                }
			}			
		} else {
			if( document.location.hash ){
				param += "&eh="+document.location.hash.substring(1);
				HistoryManager.eh = document.location.hash.substring(1);
			}
		}
		
		var addParam = "";
		if( forceRender ){
			addParam = "&detailSearch=" + "Y" ;
		}

		jQuery.ajax({
			headers:{ "cache-control": "no-cache","pragma": "no-cache" },
			type: 'GET',
			url: url+param+addParam,
			dataType : "html",
		    timeout:20000,
	        error : function(r) {
	        },
	        beforeSend:function(){
//	        	jQuery('#luxuryBanner').hide();
	        	
				if( Filter.selected == 'opt-page' ){				
					jQuery(window).scrollTop(jQuery("#band-contents").offset().top);
				}	        	
				
				$("#viewLoading").height( 1000 );
				$("#viewLoading").show();
				
				jQuery('#searchPrdList').hide();
				/* 
				jQuery('#searchPrdRecommend').hide();			
				*/
				$('#pageNavigation').html('');
				
	        },
	        success : function(result) {
	        	
	        	jQuery('#condition-data').empty();
	        	jQuery('#condition-data').html(result);

	        	var template = Handlebars.compile(jQuery('#shop-premium-templates-jbpPrmmPrdList-hbs').html());

                var currentUrl = document.location.href;
                if(currentUrl.indexOf("signature") > -1){
                    template = Handlebars.compile(jQuery('#shop-spa-templates-signature-signatureJbpPrdSect-hbs').html());
                }
                if(currentUrl.indexOf("grand") > -1){
                    template = Handlebars.compile(jQuery('#shop-spa-templates-grand-grandJbpPrdSect-hbs').html());

                    var jsonData = $.parseJSON(result);
                    var sectId = jsonData.sectId;
                    var sectValue = jsonData.sectValue;
                    var gbn = jsonData.gbn;
                    var sortType = jsonData.sortType;

                    if(gbn == 'S'){
                        sectId = sectValue;
                    }

                    jQuery('#filter-category li a').each(function() {
                        $(this).parent().removeClass('on');

                        var category = $(this).data('category');

                        if(category == sectId){
                            $(this).parent().addClass('on');
                        }

                        if($(this).parent().parent().parent().hasClass('depth') && $(this).parent().hasClass('on')){
                            $(this).parent().parent().parent().parent().addClass('on');
                        }
                    });

                    jQuery('#filter-sort li').each(function() {
                        $(this).removeClass('on');

                        var sort = $(this).data('sort');
                        if(sortType == sort){
                            $(this).addClass('on');
                        }
                    });
                }

                var html = template($.parseJSON(result));

                jQuery( "#searchPrdList" ).empty();
	        	jQuery( "#searchPrdList" ).html( html );

                var templateBanner = Handlebars.compile(jQuery('#shop-premium-templates-jbpPrmmBanner-hbs').html());
	        	var htmlBanner = templateBanner($.parseJSON(result));
	        	
	        	jQuery( "#prmmSearchBanner" ).empty();
	        	jQuery( "#prmmSearchBanner" ).html( htmlBanner );

	        	// 이미지 없을시 제거
	    	 	jQuery("ul.clearfix img").error(function() {
	    	 		if (jQuery(this).hasClass('off')) {
	    	 			jQuery(this).siblings().attr('class', 'off active');
	    	 		}
	    	 		jQuery(this).remove();
	    	 	});
	        	
	        	
	        	
	        },
            complete : function(){                       //  success, error 실행 후 최종적으로 실행
            	
	            if( $('#condition-data').html() && $('#condition-data').html().length == 0 ){
	            	return;
	            }
            	
	        	var condition;
	        	try {
	        		condition = $.parseJSON($('#condition-data').html());
	        	} catch( err ){
	        		console.log(err);
	            	jQuery('#viewLoading').hide();
	            	jQuery('#searchPrdList').show();
	        		return;
	        	}
	        	
	        	if( !condition ) return;
	        	
	        	_this.condition = condition;	        	
	        	
	        	if( $("#search-prd-cnt").length > 0 ){
	        		$("#search-prd-cnt").html( "(" + _this.toComma( condition.totalCnt ) + ")" );
	        	}
	        	
	        	if( $("#search-prd-pop-cnt").length > 0 ){
	        		$("#search-prd-pop-cnt").html(_this.toComma( condition.totalCnt ));
	        	}
	        		        	     	        
        		if( forceRender ){
        			Filter.selected = undefined;
        			Filter.resetSort(condition);
        		}
        		
        		//Filter.setTabCnt( condition.detailTab.partList );		        
	        	
	        	// history.back 을 통해 filter reset 이 필요함
	        	if( forceRender ){
	        		var decodedHashParam = {};
	        		if(  HistoryManager.eh ){
	        			decodedHashParam = JSON.parse(Base64.decode( decodeURIComponent( HistoryManager.eh ) ) );
	        		}
	        		
	        		Filter.resetFilter( decodedHashParam, null, true );
	        	}
	        	/*
	        	if( forceRender || condition.detailTab.partList[0].count > 0 ){
	        		Filter.render( condition, forceRender );
	        		
	        		// brandLayer 초기화
	        		if( condition.brandTab && condition.brandTab.subList ){
	        			BrandLayer.reset( condition.brandTab.subList );
	        		}
	        	}
	        	*/
	        	// SelectedFilter 다시 그리기
    			if( forceRender ){
    				SelectedFilters.reset(true);
    			}
    			
    			// 리스트 정렬 스크립트
    			jQuery(".img_replace>ul>li").each(function(){
    				var repImg = jQuery(".img_replace>ul>li>a");
    				var repImg_idx = repImg.find("img");
    				var length = repImg_idx.length;
    				repImg.find(".off").addClass("active");
    				if(jQuery(">a>img", this).length != 1){
    					repImg.hover(function(){
    						jQuery(this).find(".on").addClass("active");
    						jQuery(this).find(".off").removeClass("active");
    						jQuery(this).find(".off:last-child").addClass("active");
    					}, function(){
    						jQuery(this).find(".on").removeClass("active");
    						jQuery(this).find(".off").addClass("active");
    					});
    				}
    			});
    			
	        	//현재 페이지
	        	if( condition && condition.jbpPrmmSearch ){
	        	
	        		var pageIdx = condition.jbpPrmmSearch.pageNumber;
	        		//페이지당 아이템수
	        		var rowsPerPage = condition.jbpPrmmSearch.pagePrdSize || 48;
	        		//페이지범위
	        		var pageRange = condition.jbpPrmmSearch.pageRange || 10;
	        		//전체 아이템수
	        		var totalCnt = condition.totalCnt;

	        		window.PageNavigationUtil.init(pageIdx, rowsPerPage, pageRange, totalCnt);
	        	}
            	          	
            	jQuery('#viewLoading').hide();
            	jQuery('#searchPrdList').show();
            	
            	// 추천영역 재검색
            	if( Filter.selected != 'opt-page' && typeof setRcmdArea == 'function' ){
            		setRcmdArea();
            	} else {
            		jQuery( "#searchPrdRecommend" ).show();
            	}
            	
            	if( typeof callback == 'function'  ){
            		callback( _this.baseUrl+param );
            	}
            	
            	// 스크롤 올리기
//            	$('html,body').animate({scrollTop:$("#band-contents").offset().top}, 'slow');
            	$( 'html, body' ).scrollTop($("#band-contents").offset().top);

            }
		});
	},

	toComma : function(price) {
		var reg = /(^[+-]?\d+)(\d{3})/;
		price += '';
		while (reg.test(price)){
			price = price.replace(reg, '$1' + ',' + '$2');
		}

		return price;
	}
}